import { render, staticRenderFns } from "./mtCaptcha.vue?vue&type=template&id=01498f6e&lang=true&"
import script from "./mtCaptcha.vue?vue&type=script&lang=js&"
export * from "./mtCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports